import Vue from 'vue'
import Router from 'vue-router'
import usersRoute from '@/app/users/users.routes'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/users' },
    ...usersRoute
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js